import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAffineTransformation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 14 14",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m3.733.668.368 3.19-3.6-.125L0 0zM.689 5.133l3.549-.079.368 3.191-3.417.622zm.688 5.134 3.366-.826.368 3.19L1.878 14zm4.946 1.851-.317-2.987 3.366-.826.183 2.444zm4.445-1.882-.134-2.24L14 7.17v1.697zM14 6.534l-3.416.622-.134-2.24L14 4.837zm0-2.333-3.6-.125-.133-2.239L14 2.504zM8.867 1.586l.183 2.443-3.599-.124L5.133.918zm.252 3.36.184 2.443-3.416.622-.318-2.986z"
	})
});
export default SvgIconAffineTransformation;
